import React from 'react';
import { cn } from '../../shared/utils';

const Card = ({ children, className = "" }) => (
    <div className={cn("bg-white dark:bg-slate-800 rounded-xl shadow-sm border border-slate-200 dark:border-slate-700 p-5 transition-all duration-300", className)}>
        {children}
    </div>
);

export default Card;
